import React from 'react';

const OrderDetail: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Order Details</h1>
      <p>Order detail page coming soon...</p>
    </div>
  );
};

export default OrderDetail;